import type { AttendeeTagKind } from '../../types/lobbyDay'

// Note: locked/removable is driven by the tag's `system` flag (the backend's single
// source of truth for "auto-managed, locked in UI"), NOT by kind — an unrecognized
// LobbyDay label classifies as Conduct yet can still be system=true. KIND_META only
// supplies presentation (color scheme + short label) per kind.
export const KIND_META: Record<AttendeeTagKind, { color: string; short: string }> = {
  Attendance: { color: 'blue', short: 'Attended' },
  Ask:        { color: 'purple', short: 'Ask' },
  Outcome:    { color: 'teal', short: 'Outcome' },
  Conduct:    { color: 'orange', short: 'Conduct' },
}
